import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const AssignDocument = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const { checkDocuments } = useCheckBeforeAction(actionType.ASSIGNDOCUMENT);
  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    dispatch(actions.modal.openModal(modalActionType.documents.REASSIGN_USER));
  };
  return (
    <CommonButton
      id="assign-document-btn"
      action={onClick}
      disabled={!utils.user.isActionEnabled(records, actionType.ASSIGNDOCUMENT)}
      scope="tertiary"
      value={t('reassign')}
      customIcon="write"
    />
  );
};

export default AssignDocument;
